/**
 * API base URL for the Node backend (e.g. AWS Lightsail behind Nginx + TLS).
 *
 * - Development (`npm start`): defaults to http://localhost:5000 if unset.
 * - Production (`npm run build`): you MUST set REACT_APP_BACKEND_URL before build
 *   (e.g. https://api.customspro.ai or https://<lightsail-static-ip> if using IP + TLS).
 */
const DEFAULT_DEV = 'http://localhost:5000';

export function getBackendUrl() {
  const fromEnv = process.env.REACT_APP_BACKEND_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV !== 'production') {
    return DEFAULT_DEV;
  }
  throw new Error(
    'REACT_APP_BACKEND_URL is required for production builds. Set it in .env to your API URL (e.g. Lightsail: https://api.yourdomain.com).'
  );
}
